import winston from 'winston'
import isServerSide from '../isServerSide'

const winstonLogger = (app, level, loggerSilent) => {

    let logger: any = null

    if (isServerSide) {

        logger = winston.createLogger({
            level: level,
            defaultMeta: { service: app },
            format: winston.format.json(),
            handleExceptions: true,
            transports: [new winston.transports.Console()]
        });

        if (loggerSilent) {
            logger.transports.forEach((transport) => (transport.silent = true))
        }

    } else {

        logger = {
            error: msg => { },
            debug: msg => { },
            info: msg => { },
        }

    }

    return logger

}

export default winstonLogger